import classNames from "classnames";
import { useCallback, useState } from "react";

import { ampli } from "../../../ampli";
import { DialogModal } from "../../../components/common/dialog";
import PrimaryButton, {
  PrimaryButtonType,
} from "../../../components/common/PrimaryButton";
import Spinner from "../../../components/common/Spinner";
import Alert, { AlertType } from "../../../components/common/WaffyAlert";
import CustomizedSnackbars from "../../../components/customizedSnackbars";
import { IApiResponse } from "../../../setup/api/models";
import { validateOtp } from "../../../setup/api/services/otp";
import { EOTPType } from "../../../setup/api/services/otp/models";
import { updateNationalId } from "../../../setup/api/services/user";
import { fetchAndSetMyInfo } from "../../../setup/context/api";
import { AuthConfig } from "../../../setup/context/config/authConfig";
import { CONFIRM } from "../../authentication/constants";
import { AbsherStep } from "../../authentication/signup/absherStep";
import {
  ERROR_ABSHER_VALIDATION,
  ERROR_OTP_VALIDATION,
} from "../../authentication/signup/constants";
import {
  validateNationalId,
  validateOtpCode,
} from "../../authentication/validation";
import { ABSHER_SECTION } from "./constant";
import styles from "./styles.module.scss";

interface Props {
  handleRefresh: () => void;
}

const AbsherIdentification = ({ handleRefresh }: Props) => {
  const userId = AuthConfig?.getUserInfo()?.id;

  const [absherModalOpen, setAbsherModalOpen] = useState<boolean>(false);
  const [absherOtpCode, setAbhserOtpCode] = useState<string>();
  const [nationalId, setNationalId] = useState<string>();
  const [isValidNationalId, setisValidNationalId] = useState<boolean>(false);
  const [error, setError] = useState<string>();
  const [successSnackBar, setSuccessSnackBar] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const onAbsherClick = () => {
    setAbsherModalOpen(true);
  };
  const handleAbsherClose = () => {
    setAbsherModalOpen(false);
    setAbhserOtpCode(undefined);
    setNationalId(undefined);
    setisValidNationalId(false);
    setError(undefined);
  };
  const onAbsherConfirm = () => {
    setLoading(true);
    if (isValidNationalId === false) onSubmitnationalId({ userId, nationalId });
    else onSubmitAbsherOtp(userId, absherOtpCode);
  };
  const onNationalIdChange = useCallback((event: string) => {
    setError(undefined);
    setNationalId(event);
  }, []);
  const onAbhserOtpChange = useCallback((event: string) => {
    setError(undefined);
    setAbhserOtpCode(event);
  }, []);
  const onSubmitnationalId = ({ userId, nationalId }) => {
    if (userId && nationalId && validateNationalId(nationalId)) {
      updateNationalId(userId, { nationalId })
        .then(() => {
          setLoading(false);
          setisValidNationalId(true);
        })
        .catch((error: IApiResponse) => {
          setLoading(false);
          setisValidNationalId(false);
          onAbsherFailure(error.error.message);
        });
    } else {
      setLoading(false);
      onAbsherFailure(ERROR_ABSHER_VALIDATION);
    }
  };
  const sendAmpliEventVerifyAbsher = () => {
    ampli.verifiedViaAbsher({
      absherPageSource: "userProfilePage", // enum,
      resendAbsherOtpTrials: 1, // number
    });
  };
  const sendAmpliUserProperties = () => {
    ampli.client.setUserProperties({
      isAbsherVerified: true,
      absherVerificationDate: new Date().toISOString(),
    });
  };
  const onSubmitAbsherOtp = (
    userId: string,
    absherOtpCode: string | undefined
  ) => {
    if (userId && absherOtpCode && validateOtpCode(absherOtpCode)) {
      validateOtp(userId, {
        otp: Number.parseInt(absherOtpCode),
        type: EOTPType.ABSHER_OTP,
      })
        .then((res) => {
          setLoading(false);
          if (res.data.valid) {
            sendAmpliEventVerifyAbsher();
            sendAmpliUserProperties();
            onAbsherSuccess();
            handleRefresh();
          } else onAbsherFailure(ERROR_OTP_VALIDATION);
        })
        .catch((error) => {
          setLoading(false);
          handleRefresh();
          onAbsherFailure(error.message);
        });
    } else {
      setLoading(false);
      onAbsherFailure(ERROR_OTP_VALIDATION);
    }
  };
  const onAbsherSuccess = () => {
    fetchAndSetMyInfo();
    setSuccessSnackBar(true);
    handleAbsherClose();
  };
  const onAbsherFailure = (error: string) => {
    setError(error);
  };
  return (
    <>
      <CustomizedSnackbars
        title={ABSHER_SECTION.IDENTITY_CONFIRMED}
        open={successSnackBar}
        type={"success"}
      />
      <DialogModal
        title={ABSHER_SECTION.CONFIRM_YOUR_IDENTITY_THROUGH_ABSHER}
        open={absherModalOpen}
        handleClose={handleAbsherClose}
        className={styles["absher_modal"]}>
        <div className={styles.absher_container} dir="rtl">
          <div>
            <p className={classNames(styles.p1, styles.g600)}>
              {ABSHER_SECTION.MODAL_DESCRIPTION}
            </p>
            <div>
              {error && (
                <Alert type={AlertType.ERROR} showIcon>
                  {error}
                </Alert>
              )}
              <AbsherStep
                onNationalIdChange={onNationalIdChange}
                onOtpChange={onAbhserOtpChange}
                isValidNationalId={isValidNationalId}
              />
              <div className={styles["button_container"]}>
                <PrimaryButton
                  id={"absher_confirm"}
                  onClick={onAbsherConfirm}
                  buttonType={PrimaryButtonType.ABSHER}>
                  {loading ? (
                    <Spinner />
                  ) : (
                    <h3 className={styles.white}>{CONFIRM}</h3>
                  )}
                </PrimaryButton>
              </div>
            </div>
          </div>
        </div>
      </DialogModal>
      <br />
      <div className={styles.absherContainer}>
        <img alt="img" src="/assets/images/svg/absher.svg" />

        <h2
          onClick={onAbsherClick}
          className={classNames(
            styles.absherTitle,
            styles.primary,
            styles.pointer
          )}>
          {ABSHER_SECTION.CONFIRM_YOUR_IDENTITY_THROUGH_ABSHER}
        </h2>
      </div>
    </>
  );
};

export default AbsherIdentification;
